<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px;height:auto !important;"
          toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Request For Quotation</b-navbar-brand>

          <b-navbar-nav class="ml-auto" center>
            <b-nav-form><b-button size="sm" variant="warning" @click="goToMain">Request For Quotation
                Order</b-button></b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <!-- Search Form Input Start-->
            <div class="mt-3">
              <b-row>
                <b-col md="4" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Request For Quotation" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2" class="my-1">
                  <model-list-select @input="All_Research_Quotation_List_data" :list="StatusList" v-model="Status"
                    option-value="inv" option-text="int" placeholder="Select Status"></model-list-select>
                </b-col>
                <b-col md="2" class="my-1">
                  <model-list-select class="ml-1" :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="branchfilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="All_Research_Quotation_List_data"></model-list-select>
                </b-col>
                <b-col md="3" class="my-1">
                  <date-range-picker :opens="openLeft" :always-show-calendars="showCal" v-model="dateRange"
                    :startDate="startDate" :endDate="endDate" @update="debounceSearch"></date-range-picker>
                </b-col>
                <b-col md="1">
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
            </div>
            <!-- Search Form Input End-->

            <div class="mt-3">
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="stockList" responsive :fields="Columns"
                  primary-key="common_over_id" :per-page="perPage" :current-page="currentPage" :filter="filter"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  class="position-relative">
                  <template slot="RQ_ID" slot-scope="row0">
                    <span>
                      {{ row0.index + 1 + (currentPage - 1) * perPage }}
                    </span>
                  </template>
                  <template slot="RQseries" slot-scope="row9">
                    <span @click="viewAddRQPage(row9.item.RQ_ID)">
                      {{
                      row9.item.RQseries !=
                      "" ? row9.item.RQseries : "--"
                      }}
                    </span>
                    <br />
                    <span>Created Date : {{ row9.item.creationTime | moment }}</span><br />
                    <span>Raised From : {{ row9.item.branchName }}</span>
                  </template>
                  <!-- <template slot="OnApprove" slot-scope="row28">
                          <div>
                            <h6>
                              <b-badge>{{row28.item.on_approve==1?'Approve':'Reject'}}</b-badge>
                            </h6>
                          </div>
                        </template> -->
                  <template slot="placeOfIssue" slot-scope="row1">
                    <span> {{row1.item.location != "" ? row1.item.location : "--"}}</span>
                  </template>
                  <template slot="itemQuantity" slot-scope="row2">
                    <span>{{row2.item.itemName != "" ? row2.item.itemName : "--"}}</span>
                  </template>
                  <template slot="isReseAndQuoActive" slot-scope="row22">
                    <div :id="'row'+row22.item.RQ_ID">
                      <h6>
                        <b-badge>{{row22.item.isReseAndQuoActive==1?'Active':'In-Active'}}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="docuemnt_rfq" slot-scope="row56">
                    <b-button v-if="row56.item.docuemnt_rfq != null"
                      @click="PrintNote(row56.item.RQseries, row56.item.docuemnt_rfq)" size="sm"
                      variant="outline-success">PDF</b-button>
                    <span v-else>N/A</span>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="5" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>
  
  <script>
    import DatePicker from "vue2-datepicker";
    import axios from "axios";
    import moment from "moment";
    import { ModelListSelect, MultiSelect } from "vue-search-select";
  // import Loading from "vue-loading-overlay";
  import CustomLoader from "../../common/customLoader.vue";
    import "vue-loading-overlay/dist/vue-loading.css";
    import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
    import { DateFormat, selectDateFormat} from "../../../helper/filters.js";
    import { globalPermissionStatus } from "../../../helper/collection.js";
    import DateRangePicker from "vue2-daterange-picker";
    import MaintenanceService from "../../../services/MaintenanceService.js";

    export default {
        beforeMount() {
            if (globalPermissionStatus("Maintanence")) {
              this.$store.dispatch("setCurrentRoute", "/Res&Quo/Res&Quo");
              this.All_Research_Quotation_List_data();
            } else {
                this.$router.push({
                    path: "/dashboard"
                });
            }
            this.$store.dispatch(
                "common/setAllBranchList",
                JSON.stringify({
                filter: "BranchList",
                active: "all"
                })
            );
        },
        data() {
          return {
              ExcelBtnName: "Export As Excel",
              addEditCard: false,
              isLoading: false,
              showCal: false,
              selectDateFormat,
              openLeft: "left",
              StatusList: [
                {
                  inv: "2",
                  int: "All",
                },
                {
                  inv: "0",
                  int: "Inactive",
                },
                {
                  inv: "1",
                  int: "Active",
                }
              ],
              Columns: [
                {
                    key: "RQ_ID",
                    label: "SN",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                    key: "RQseries",
                    label: "R & Q Series",
                    sortable: true,
                    sortDirection: "desc",
                },
                // {
                //     key: "OnApprove",
                //     label: "Approve Status",
                //     sortable: true,
                //     sortDirection: "desc",
                // },
                {
                    key: "isReseAndQuoActive",
                    label: "Status",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                    key: "placeOfIssue",
                    label: "For Branch",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                    key: "itemQuantity",
                    label: "Item Name",
                    sortable: true,
                    sortDirection: "desc",
                },
                {
                    key: "docuemnt_rfq",
                    label: "Document Name",
                    sortable: true,
                    sortDirection: "desc",
                },
              ],
              Status: "1",
              docURL: URL_BASE_DOC,
              currentPage: 1,
              perPage: 10,
              totalRows: "",
              sortBy: null,
              sortDesc: false,
              pageOptions: [5, 10, 15],
              adminToggle: this.$sessionsStorage.get(),
              sortDirection: "desc",
              filter: null,
              branchfilter: "",
              changePageFilter: "0",
              modalInfo: { title: "", content: "" },
              alert: {
              content: "Added Succesfully",
              ok: "ok",
              },
              stockList: [],
              All_Pridel_Document_data: [],
              All_Document_TypeList: [],
              validate: true,
              visible: false,
              dateRange: {
                startDate: "",
                endDate: "",
              },
              dateSearch: {
                fromDate: "",
                toDate: "",
              },
              startDate: "2017-09-05",
              endDate: "2017-09-15",
          };
        },
        filters: {
        moment(date) {
            return DateFormat(date);
        },
        },
        mounted() {},
    
        beforeDestroy() {},
    
        destroyed() {},
    
        components: {
          // Loading,
          CustomLoader,
          DatePicker,
          ModelListSelect,
          DateRangePicker,
          MaintenanceService,
        },
        created() {
        },
        computed: {
          sortOptions() {
              // Create an options list from our fields
              return this.Columns.filter((f) => f.sortable).map((f) => {
              return { text: f.label, value: f.key };
              });
          },
          locationMasterList() {
            return this.locationMaster;
          },
          
        },
        methods: {
            PrintNote(RQseries, document_rfq) {
              let key =
                "ASSIGNMENT_UPLOADS/" +
                RQseries.replaceAll("/", "_") +
                "/" +
                document_rfq;
              this.openSignedDocument(key);
            },
            goToMain() {
                this.$sessionsStorage.set("editROQId", "");
                this.$router.push({
                    path: "/ResOfQuo/addResOfQuo"
                });
            },
            viewAddRQPage(poID) {
                this.$sessionsStorage.set("editROQId", poID);
                this.$router.push({
                    path: "/ResOfQuo/addResOfQuo"
                });
            },
            All_Research_Quotation_List_data() {
              this.isLoading = true;
              let payload = {
                  itemCode: "Request_Data_List",
                  RQ_ID: "",
                  Status: this.Status,
                  location: this.branchfilter,
                  dateRange: this.dateRange,
              };
              MaintenanceService.getAllMaintenanceList(payload)
              .then(result => {
                const { statusText, status, data } = result;
                if (status == 200 && data) {
                    this.stockList = data.itemArray;
                    this.totalRows = data.itemArray.length;
                } else {
                    this.All_Research_Quotation_List_data = [];
                }
                this.isLoading = false;
              })
              .catch(error => {});
            },
            JqueryFun() {
                return $(function () {
                return $("#portLocationNew").DataTable();
                });
            },
            debounceSearch(event) {
              clearTimeout(this.debounce);
              this.debounce = setTimeout(() => {
                this.All_Research_Quotation_List_data();
              }, 1000);
            },
            setFocus: function () {
                // Note, you need to add a ref="search" attribute to your input.
                this.$refs.search.focus();
            },
        },
    };
  </script>
  
  <style>
    .md-direction-bottom-right {
      width: 30% !important;
    }
    .mrgtop-2per {
      margin-top: 1%;
    }
    .mrgtop-5px {
      margin-top: 0px;
    }
    .center {
      text-align: center;
    }
    .heght-1px {
      height: 1px;
    }
    
    .b-form-input-container {
      margin: 4px 0 12px !important;
    }
    .md-button-color {
      background-color: #607d8d !important;
    }
    
    .md-button-color-toggle {
      background-color: rgba(153, 153, 153, 0.4) !important;
    }
    
    .activeClass {
      display: none;
    }
    .error {
      color: red;
    }
  </style>


// WEBPACK FOOTER //
// ResOfQuo.vue?81ec6e0e